import type { FilterOptions } from '../filters/useFilterOptions'
import type { OptionDef, Register } from '../query/types'
import type { BulkActionKey, BulkRequest } from './BulkMenus'

/** An action that asks first and is no delete. */
export function ask(action: BulkActionKey, params: Record<string, unknown>, summary: string): BulkRequest {
  return { action, params, summary, confirm: true, destructive: false }
}

/** The choices behind the property with this key; null while they load, none when the register has no such property. */
export function choicesOf(register: Register, options: FilterOptions, key: string): OptionDef[] | null {
  const property = register.properties.find((candidate) => candidate.key === key)
  return property ? options.optionsFor(property) : []
}
